import {
  WORKGROUPDETAIL_LOADING,
  GET_WORKGROUPDETAIL,
  GET_WORKGROUPDETAIL_SUCCESS,
  GET_WORKGROUPDETAIL_FAIL,
  ADD_WORKGROUPDETAIL_SUCCESS,
  ADD_WORKGROUPDETAIL_FAIL,
  DELETE_WORKGROUPDETAIL_SUCCESS,
  DELETE_WORKGROUPDETAIL_FAIL,
  UPDATE_WORKGROUPDETAIL_SUCCESS,
  UPDATE_WORKGROUPDETAIL_FAIL,
  WORKGROUPDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  workGroupDetails: [],
  error: {},
};

const WorkGroupDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_WORKGROUPDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_WORKGROUPDETAIL:
          return {
            ...state,
            workGroupDetails: action.payload.data,
            isWorkGroupDetailCreated: false,
            isWorkGroupDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_WORKGROUPDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_WORKGROUPDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isWorkGroupDetailCreated: false,
            isWorkGroupDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_WORKGROUPDETAIL: {
      return {
        ...state,
        isWorkGroupDetailCreated: false,
        loading: true,
      };
    }

    case WORKGROUPDETAIL_LOADING: {
      return {
        ...state,
        isWorkGroupDetailCreated: false,
        loading: true,
      };
    }

    case ADD_WORKGROUPDETAIL_SUCCESS:
      return {
        ...state,
        isWorkGroupDetailCreated: true,
        loading: false,
        workGroupDetails: [action.payload.data, ...state.workGroupDetails],
      };

    case ADD_WORKGROUPDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_WORKGROUPDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isWorkGroupDetailCreated: true,
        workGroupDetails: state.workGroupDetails.filter(
          workGroupDetail => workGroupDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_WORKGROUPDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_WORKGROUPDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isWorkGroupDetailCreated: true,
        workGroupDetails: state.workGroupDetails.map(workGroupDetail =>
          workGroupDetail.id.toString() === action.payload.data.id.toString() ? { ...workGroupDetail, ...action.payload.data } : workGroupDetail
        ),
      };

    case UPDATE_WORKGROUPDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case WORKGROUPDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default WorkGroupDetail;